<div class="hiddenTitle roiTitle announcement">
  <div class="container upper">
    <h1>{{"common.text_smartire_header" | cxTranslate }}</h1>
  </div>
</div>

<div class="container smartire-container">

  <div class="content" id="top">
    <div class="section smartire-section">
      <h1 class="roi-h1">{{"common.text_smartire_return_investment" | cxTranslate }}</h1>
      <h3 class="roi-h3">{{"common.text_smartire_return_bottom_line" | cxTranslate }}</h3>
      <p class="roi-para">{{"common.text_smartire_return_bottom_line_para" | cxTranslate }}</p>
    </div>


    <div class="section smartire-section">
      <h3 class="roi-h3">{{"common.text_smartire_return_smartware" | cxTranslate }}</h3>
      <p class="roi-para">{{"common.text_smartire_return_smartware_para" | cxTranslate }}</p>
    </div>


    <div class="section smartire-section">
      <h3 class="roi-h3">{{"common.text_smartire_return_calculator" | cxTranslate }}</h3>
      <p class="roi-para">{{"common.text_smartire_return_calculator_para" | cxTranslate }}</p>

      <form [formGroup]="roiCalculatorForm" (ngSubmit)="onSubmit()" class="calculator" id="roi_calculator">
        <table cellpadding="0" cellspacing="0" class="table table-bordered table-blue roi-table">
          <tr>
            <th>{{"common.text_smartire_company_info" | cxTranslate}}</th>
            <th class="line">{{"common.text_smartire_units" | cxTranslate}}</th>
          </tr>
          <tr>
            <td>{{"common.text_smartire_numberof_vahicles" | cxTranslate}}</td>
            <td class="line"><input type="text" formControlName="roi_number_vehicles"
              id="roi_number_vehicles"
              (focus)="onFieldFocus($event,100,'roi_number_vehicles')" />{{"common.text_smartire_vehicles"
              |
              cxTranslate}}
              @if (roiCalculatorForm.get('roi_number_vehicles').invalid && roiCalculatorForm.get('roi_number_vehicles').touched) {
                <p
                class="roi-error Num-Vehc">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
              }
            </td>
          </tr>
          <tr>
            <td>{{"common.text_smartire_average_mileage" | cxTranslate}}</td>
            <td class="line"><input type="text" formControlName="roi_avg_mileage" id="roi_avg_mileage"
              (focus)="onFieldFocus($event,75000,'roi_avg_mileage')" />{{"common.text_smartire_per_year"
              |
              cxTranslate}}
              @if (roiCalculatorForm.get('roi_avg_mileage').invalid && roiCalculatorForm.get('roi_avg_mileage').touched) {
                <p
                class="roi-error avg-mil">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
              }
            </td>
          </tr>
          <tr>
            <td>{{"common.text_smartire_numberof_tires" | cxTranslate}}</td>
            <td class="line"><input type="text" formControlName="roi_number_tires" id="roi_number_tires"
              (focus)="onFieldFocus($event,8,'roi_number_tires')" />{{"common.text_smartire_tires" |
              cxTranslate}}
              @if (roiCalculatorForm.get('roi_number_tires').invalid && roiCalculatorForm.get('roi_number_tires').touched) {
                <p
                class="roi-error num-tires">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
              }
            </td>
          </tr>
          <tr>
            <td>{{"common.text_smartire_tire_inspection" | cxTranslate}}</td>
            <td class="line"><input type="text" formControlName="roi_inspection" id="roi_inspection"
              (focus)="onFieldFocus($event,2,'roi_inspection')" />{{"common.text_smartire_per_month" |
              cxTranslate}}
              @if (roiCalculatorForm.get('roi_inspection').invalid && roiCalculatorForm.get('roi_inspection').touched) {
                <p
                class="roi-error inspection">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
              }
            </td>
          </tr>
          <tr>
            <td>{{"common.text_smartire_average_under_inflation" | cxTranslate}}</td>
            <td class="line"><input type="text" formControlName="roi_inflation" id="roi_inflation"
              (focus)="onFieldFocus($event,15,'roi_inflation')" /> %
              @if (roiCalculatorForm.get('roi_inflation').invalid && roiCalculatorForm.get('roi_inflation').touched) {
                <p
                class="roi-error inflation">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
              }
            </td>
          </tr>
          <tr>
            <td>{{"common.text_smartire_average_anual_downtime" | cxTranslate}}</td>
            <td class="line">
              <input type="text" formControlName="roi_downtime" id="roi_downtime"
                onfocus="if(this.value=='1') this.value='';"
                (focus)="onFieldFocus($event,1,'roi_downtime')" />{{"common.text_smartire_instance" |
                cxTranslate}}
                <input type="text" formControlName="roi_downtime_vehicles" id="roi_downtime_vehicles"
                  class="smallT" value="2"
                  (focus)="onFieldFocus($event,2,'roi_downtime_vehicles')" />{{"common.text_smartire_vehicles"
                  |
                  cxTranslate}}
                  @if (roiCalculatorForm.get('roi_downtime').invalid && roiCalculatorForm.get('roi_downtime').touched) {
                    <p
                      class="roi-error annual-downtime">{{"common.text_smartire_error_numeric" | cxTranslate}}
                    </p>
                  }
                  @if (roiCalculatorForm.get('roi_downtime_vehicles').invalid && roiCalculatorForm.get('roi_downtime_vehicles').touched) {
                    <p
                      class="roi-error downtime-vehc">{{"common.text_smartire_error_numeric" | cxTranslate}}
                    </p>
                  }
                </td>
              </tr>
              <tr>
                <td>{{"common.text_smartire_tire_life" | cxTranslate}}</td>
                <td class="line"><input type="text" formControlName="roi_tire_life" id="roi_tire_life"
                  (focus)="onFieldFocus($event,125000,'roi_tire_life')" />{{"common.text_smartire_miles" |
                  cxTranslate}}
                  @if (roiCalculatorForm.get('roi_tire_life').invalid && roiCalculatorForm.get('roi_tire_life').touched) {
                    <p
                    class="roi-error tire-life">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
                  }
                </td>
              </tr>
              <tr>
                <td>{{"common.text_smartire_fuel_cunsumption" | cxTranslate}}</td>
                <td class="line"><input type="text" formControlName="roi_fuel_consumption"
                  id="roi_fuel_consumption" value=""
                  (focus)="onFieldFocus($event,7.35,'roi_fuel_consumption')" />{{"common.text_smartire_us_mpg"
                  |
                  cxTranslate}}
                  @if (roiCalculatorForm.get('roi_fuel_consumption').invalid && roiCalculatorForm.get('roi_fuel_consumption').touched) {
                    <p
                    class="roi-error fuel-consum">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
                  }
                </td>
              </tr>
            </table>

            <table cellpadding="0" cellspacing="0" class="table table-bordered table-blue roi-table">
              <tr>
                <th>{{"common.text_smartire_deafult_values" | cxTranslate}}</th>
                <th>{{"common.text_smartire_units" | cxTranslate}}</th>
              </tr>
              <tr>
                <td>{{"common.text_smartire_cost_fuel" | cxTranslate}}</td>
                <td class="line">$<input type="text" formControlName="roi_cost_fuel" id="roi_cost_fuel"
                  (focus)="onFieldFocus($event,2.70,'roi_cost_fuel')" />{{"common.text_smartire_usd_per_gallon"
                  | cxTranslate}}
                  @if (roiCalculatorForm.get('roi_cost_fuel').invalid && roiCalculatorForm.get('roi_cost_fuel').touched) {
                    <p
                    class="roi-error cost-fuel">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
                  }
                </td>
              </tr>
              <tr>
                <td>{{"common.text_smartire_cost_per_tire" | cxTranslate}}</td>
                <td class="line">$<input type="text" formControlName="roi_cost_tire" id="roi_cost_tire"
                  (focus)="onFieldFocus($event,350,'roi_cost_tire')" />{{"common.text_smartire_usd" |
                  cxTranslate}}
                  @if (roiCalculatorForm.get('roi_cost_tire').invalid && roiCalculatorForm.get('roi_cost_tire').touched) {
                    <p
                    class="roi-error cost-tire">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
                  }
                </td>
              </tr>
              <tr>
                <td>{{"common.text_smartire_cost_downtime" | cxTranslate}}</td>
                <td class="line">$<input type="text" formControlName="roi_cost_downtime" id="roi_cost_downtime"
                  (focus)="onFieldFocus($event,500,'roi_cost_downtime')" />{{"common.text_smartire_usd" |
                  cxTranslate}}
                  @if (roiCalculatorForm.get('roi_cost_downtime').invalid && roiCalculatorForm.get('roi_cost_downtime').touched) {
                    <p
                      class="roi-error cost-downtime">{{"common.text_smartire_error_numeric" | cxTranslate}}
                    </p>
                  }
                </td>
              </tr>
              <tr>
                <td>{{"common.text_smartire_service_cost" | cxTranslate}}</td>
                <td class="line">$<input type="text" formControlName="service_cost_per_vehicle"
                  id="service_cost_per_vehicle" class="smallT" readonly /> &#64;
                  <input type="text" formControlName="roi_service_minutes" id="roi_service_minutes"
                    class="smallT" value="2"
                    (change)="calculateServiceCost()" />{{"common.text_smartire_minutes_per_tire" |
                    cxTranslate}} &nbsp; &amp; &nbsp; $
                    <input type="text" formControlName="roi_service_perhour" id="roi_service_perhour"
                      class="smallT" value="15" (focus)="onFieldFocus($event,15,'roi_service_perhour')"
                      (change)="calculateServiceCost()" />{{"common.text_smartire_usd_per_hour" |
                      cxTranslate}}
                      @if (roiCalculatorForm.get('roi_service_minutes').invalid && roiCalculatorForm.get('roi_service_minutes').touched) {
                        <p
                        class="roi-error service-min">{{"common.text_smartire_error_numeric" | cxTranslate}}</p>
                      }
                      @if (roiCalculatorForm.get('roi_service_perhour').invalid && roiCalculatorForm.get('roi_service_perhour').touched) {
                        <p
                          class="roi-error service-hour">{{"common.text_smartire_error_numeric" | cxTranslate}}
                        </p>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="line">
                      <button type="submit" id="roi-calc-btn" class="btn">
                        {{'common.text_smartire_btn_calculate' | cxTranslate}}
                        <img src="/icons/link-white.svg" alt="submit" class="icon-right" />
                      </button>
                    </td>
                  </tr>
                </table>
                <div id="roi_results">
                  <table cellpadding="0" cellspacing="0" class="normalT table table-bordered table-blue roi-table">
                    <tr>
                      <th>{{"common.text_smartire_xyz_trucking_co" | cxTranslate}}</th>
                      <th>{{"common.text_smartire_normal" | cxTranslate}}</th>
                      <th>{{"common.text_smartire_with_smartwave" | cxTranslate}}</th>
                      <th class="line">{{"common.text_smartire_saving" | cxTranslate}}</th>
                    </tr>
                    <tr>
                      <td>{{"common.text_smartire_annual_tire_cost" | cxTranslate}}</td>
                      <td id="res1_norm" [align]="'left'">{{CurrencyFormatted(results?.res1_norm) }}</td>
                      <td id="res1_smar" [align]="'left'">{{ CurrencyFormatted(results?.res1_smar )}}</td>
                      <td id="res1_save" [align]="'left'" class="line"> {{ CurrencyFormatted(results?.res1_save)
                      }}</td>
                    </tr>
                    <tr>
                      <td>{{"common.text_smartire_annual_fuel_cost" | cxTranslate}}</td>
                      <td id="res2_norm" [align]="'left'"> {{ CurrencyFormatted (results?.res2_norm)}}</td>
                      <td id="res2_smar" [align]="'left'">{{ CurrencyFormatted (results?.res2_smar) }}</td>
                      <td id="res2_save" [align]="'left'" class="line">{{CurrencyFormatted(results?.res2_save) }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{"common.text_smartire_annual_tire_maintenance_cost" | cxTranslate}}</td>
                      <td id="res3_norm" [align]="'left'">{{ CurrencyFormatted(results?.res3_norm) }}</td>
                      <td id="res3_smar" [align]="'left'">&nbsp;{{ CurrencyFormatted(results?.res3_smar) }}</td>
                      <td id="res3_save" [align]="'left'" class="line">{{ CurrencyFormatted(results?.res3_save) }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{"common.text_smartire_annual_downtime_cost" | cxTranslate}}</td>
                      <td id="res4_norm" [align]="'left'">{{ CurrencyFormatted(results?.res4_norm) }}</td>
                      <td id="res4_smar" [align]="'left'">{{ CurrencyFormatted(results?.res4_smar) }}</td>
                      <td id="res4_save" [align]="'left'" class="line">{{ CurrencyFormatted(results?.res4_save)}}
                      </td>
                    </tr>
                    <tr>
                      <td><strong>{{"common.text_smartire_total" | cxTranslate}}</strong></td>
                      <td id="tot_norm" [align]="'left'"><strong>{{ CurrencyFormatted(results?.tot_norm)
                      }}</strong></td>
                      <td id="tot_smar" [align]="'left'"><strong>{{ CurrencyFormatted(results?.tot_smar)
                      }}</strong></td>
                      <td id="tot_save" [align]="'left'" class="line"><strong>{{
                      CurrencyFormatted(results?.tot_save)}}</strong></td>
                    </tr>
                  </table>

                  <table cellpadding="0" cellspacing="0" class="normalT table table-bordered table-blue roi-table">
                    <tr>
                      <th class="line" [align]="'left'">{{"common.text_smartire_annual_saving" | cxTranslate}}
                      </th>
                      <th id="tot_anual" class="line">{{ CurrencyFormatted(results?.tot_anual)}}</th>
                    </tr>
                  </table>

                  <h3 class="roi-h3">{{"common.text_smartire_calculate_following" | cxTranslate}}</h3>
                  <ul class="list roi-val-list">
                    <li>{{"common.text_smartire_reduce_tire_thread" | cxTranslate}}</li>
                    <li>{{"common.text_smartire_reduce_fuel_economy" | cxTranslate}}</li>
                    <li>{{"common.text_smartire_tire_failure" | cxTranslate}}</li>
                    <li>{{"common.text_smartire_tire_related" | cxTranslate}}</li>
                    <li>{{"common.text_smartire_smartwave_tpms" | cxTranslate}}<input type="text"
                    formControlName="roi_reduce" id="roi_reduce" class="smallT" value="40" />%</li>
                  </ul>
                </div>
              </form>
            </div>
          </div>
        </div>